// use this method inside of a function
export const debounce = (
  func: () => void,
  delay: number,
  timeoutId?: NodeJS.Timeout
) => {
  let timeout: NodeJS.Timeout | undefined = timeoutId;

  if (timeout) {
    clearTimeout(timeout);
  }

  timeout = setTimeout(() => {
    func();
  }, delay);

  return timeout;
};
